{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Product access never confers inspection, certification, release, or operational authority.",
  "roles": [
    {
      "id": "technician",
      "name": "Technician / A&P",
      "domain": "shop"
    },
    {
      "id": "inspector",
      "name": "Inspector",
      "domain": "shop"
    },
    {
      "id": "lead-technician",
      "name": "Lead Technician",
      "domain": "shop"
    },
    {
      "id": "production-control",
      "name": "Production Control",
      "domain": "shop"
    },
    {
      "id": "planner",
      "name": "Maintenance Planner",
      "domain": "shared"
    },
    {
      "id": "parts-coordinator",
      "name": "Parts Coordinator",
      "domain": "shared"
    },
    {
      "id": "records-specialist",
      "name": "Records / Closeout Specialist",
      "domain": "shared"
    },
    {
      "id": "quality-manager",
      "name": "Quality Manager",
      "domain": "shop"
    },
    {
      "id": "accountable-manager",
      "name": "Accountable Manager",
      "domain": "shop"
    },
    {
      "id": "shop-administrator",
      "name": "Shop Administrator",
      "domain": "shop"
    },
    {
      "id": "customer-service",
      "name": "Customer Service Representative",
      "domain": "shop"
    },
    {
      "id": "director-of-maintenance",
      "name": "Director of Maintenance",
      "domain": "operate"
    },
    {
      "id": "maintenance-control",
      "name": "Maintenance Control",
      "domain": "operate"
    },
    {
      "id": "fleet-manager",
      "name": "Fleet Manager",
      "domain": "operate"
    },
    {
      "id": "compliance-manager",
      "name": "Compliance Manager",
      "domain": "operate"
    },
    {
      "id": "aircraft-owner",
      "name": "Aircraft Owner",
      "domain": "external"
    },
    {
      "id": "operator-representative",
      "name": "Operator Representative",
      "domain": "external"
    },
    {
      "id": "auditor",
      "name": "Auditor (read-only)",
      "domain": "external"
    },
    {
      "id": "tenant-administrator",
      "name": "Tenant Administrator",
      "domain": "platform"
    },
    {
      "id": "security-administrator",
      "name": "Security Administrator",
      "domain": "platform"
    }
  ]
}